module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("10")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Hier ist")]), _vm._v(" dein Schemel,\ndort ruhn"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeine Füße, wo die Ärmsten und Niedersten,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwo die Verlorenen leben.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wenn ich versuche, mich dir zu neigen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkann mein Haupt nicht die Tiefe erreichen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwo deine Füße ruhen unter den Ärmsten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nund Niedersten, den Verlorenen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Stolz kann niemals sich nähern, wo du"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\numher gehst in den Gewändern der Demütigen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nunter den Ärmsten und Niedersten,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nden Verlorenen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mein Herz findet nie seinen Weg dorthin,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwo du Freundschaft hältst mit den"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nFreundlosen unter den Ärmsten, den Niedersten,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nden Verlorenen. "), _c('a', {
    attrs: {
      "id": "page13",
      "title": "mabarosa/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ea57d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0011.vue
// module id = 87
// module chunks = 0